<div class="container">
  <div class="container-inner">
    <div class="left">
      <div class="better-logo">
        <a
          target="_blank"
          href="https://www.better-health-project.eu/#/"
          class="project-title"
        >
          <img src="images/better_logo.png" alt="BETTER logo" />
        </a>
      </div>
    </div>
    <div class="right">
      <div class="eu-commission-logo">
        <img src="images/e_commission.png" alt="EU Commission logo" />
      </div>
      <div class="eu-note">
        The project has received funding from the European Union's Horizon
        Europe research and innovation programme under
        <a
          target="_blank"
          href="https://cordis.europa.eu/project/id/101136262"
          class="grant-agreement"
          >grant agreement No 101136262</a
        >. The communication reflects only the author's view and the Commission
        is not responsible for any use that may be made of the information it
        contains.
      </div>
    </div>
  </div>
</div>
